import gif from "../../assets/gif/drone-gif.gif";

// src/components/Loader.jsx
export default function Loader() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#fff",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column", // Stack vertically
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={gif}
        alt="Loading..."
        style={{ width: "100px", height: "100px" }}
      />
      <p
        style={{
          marginTop: "10px",
          color: "#113C66", // Blue color
          fontWeight: "bold",
          fontSize: "20px",
          fontFamily: "Inter, sans-serif",
        }}
      >
        Drone<span style={{color:'#328ECE'}}> Planet</span>
      </p>
    </div>
  );
}
